<template>
	<div>
		<h3>Ordenes de trabajo de {{ user.name + user.lastName }}</h3>
		<v-simple-table dense height="300px">
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left minwidthtabla">
							ID
						</th>
						<th class="text-left minwidthtabla">
							Tipo
						</th>
						<th class="text-left minwidthtabla">
							Fecha
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="loading">
						<td colspan="3" style="height:100px">
							<div class="warning--text font-weight-bold">
								cargando...
							</div>
						</td>
					</tr>
					<tr v-for="(item, i) in items" :key="i">
						<td class="text-left">
							{{ item.id }}
						</td>
						<td class="text-left">{{ item.type }}</td>
						<td class="text-left">{{ item.date }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: {
		user: {
			type: Object,
			default: null,
		},
	},
	computed: {
		items() {
			let result = [];
			const audits = this.audits.flatMap(audit =>
				audit.activities
					.filter(item => item.type === 'add-work-order')
					.flatMap(item => item.data)
			);
			for (const data of audits) {
				// logitud de data para obtener la ultima orden "la nueva de esa auditoria"
				const long = Object.keys(data).length;
				result.push(data[long - 2]);
			}

			// formateamos los datos para la tabla
			result = result.map(wo => {
				if (Array.isArray(wo)) {
					return {
						id: wo[0],
						date: wo[1],
						type: wo[wo.length - 1],
					};
				}
				return {
					id: wo.id,
					date: wo.date,
					type: wo.type,
				};
			});

			return result;
		},
		...mapGetters({
			audits: 'Audit/audits',
			loading: 'Audit/loading',
		}),
	},
};
</script>

<style lang="scss" scoped></style>
